// features/counterSlice.js
import { createSlice } from '@reduxjs/toolkit';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    loggedInStatus: false,
    userDetails: {},
    userId: '',
  },
  reducers: {
    setLoginStatus: (state, action) => {
      state.loggedInStatus = action.payload;
    },
    setUserDetails: (state, action) => {
      state.userDetails = action.payload;
    },
    setUserId: (state, action) => {
      state.userId = action.payload;
    },
  },
});

export const { setLoginStatus, setUserDetails, setUserId } =
  authSlice.actions;
export default authSlice;
